import { ConnectionManagerNetworkKeys as networkKeys } from '../constants';

export default function createRequestBodyFactory(connection, accountId) {
  const userId = sessionStorage.getItem('userId');
  switch (connection.network.type) {
    case networkKeys.PIGEON_HOLE:
      return {
        label: connection.title.trim(),
        apiKey: connection.apiKey.trim(),
        account: `/account/${accountId}`,
        user: `/users/${userId}`,
      };
    default:
      return {
        label: connection.title.trim(),
        accessToken: connection.accessToken.trim(),
        refreshToken: connection.refreshToken.trim(),
        account: `/account/${accountId}`,
        user: `/users/${userId}`,
      };
  }
}
